import { render, staticRenderFns } from "./RelationRow.vue?vue&type=template&id=263503be&scoped=true&"
import script from "./RelationRow.vue?vue&type=script&lang=js&"
export * from "./RelationRow.vue?vue&type=script&lang=js&"
import style0 from "./RelationRow.vue?vue&type=style&index=0&id=263503be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "263503be",
  null
  
)

export default component.exports